import {broadcastAction, frameAction} from "atg-store-addons";

import type {Solace} from "@atg-frame-shared/push";

export const INIT = "solace/INIT";
export const CONNECTED = "solace/CONNECTED";
export const RECONNECTED = "solace/RECONNECTED";
export const TEST_SOLACE_EVENT = "solace/TEST_SOLACE_EVENT";
export const START_SESSION_EVENT_LISTENER = "solace/START_SESSION_EVENT_LISTENER";

export type ConnectedAction = {
    type: typeof CONNECTED;
    client: Solace;
};

export type ReconnectedAction = {
    type: typeof RECONNECTED;
    client: Solace;
};

export type InitAction = {
    type: typeof INIT;
};

export type StartSessionEventListenerAction = {
    type: typeof START_SESSION_EVENT_LISTENER;
};

export type TestSolaceEventAction = {
    type: typeof TEST_SOLACE_EVENT;
    eventCode: number;
};

export type PushAction =
    | ConnectedAction
    | ReconnectedAction
    | InitAction
    | StartSessionEventListenerAction
    | TestSolaceEventAction;

export const connected = (client: Solace): ConnectedAction =>
    broadcastAction({
        type: CONNECTED,
        client,
    });

export const reconnected = (client: Solace): ReconnectedAction =>
    broadcastAction({
        type: RECONNECTED,
        client,
    });

export const init = (): InitAction => ({
    type: INIT,
});

export const startSessionEventListener = (): StartSessionEventListenerAction =>
    frameAction({
        type: START_SESSION_EVENT_LISTENER,
    });

export const testSolaceEvent = (eventCode: number): TestSolaceEventAction => ({
    type: TEST_SOLACE_EVENT,
    eventCode,
});
